import { Component, inject, OnInit } from '@angular/core';
import { AppModule } from '../../app-module';
import { OccFilterComponent } from '../../commons/components/filters/OCC/occ.filter.component';
import { FiltroExpediente } from '../../commons/components/filters/court-filter.class';
import { ModalIframeService } from '../../commons/components/modal-iframe/modal-iframe.service';
import { AuthService } from '../../commons/services/auth.service';
import { v4 as uuidv4 } from 'uuid';
import { ListaArchivosComponent } from '../../commons/components/downLoadFile/lista-archivos/lista-archivos.component';
import { Documents } from '../../commons/class/archivo.inteface';
import { ConfirmationDialogService } from '../../commons/components/confirm-dialog/confirm-dialog.service';
import { AlertService } from '../../commons/components/alert/alert.service';
import { ElectronicDemandService } from './electronicDemand.service';
import { AlertComponent } from '../../commons/components/alert/alert.component';
import { LoaderComponent } from '../../commons/components/loader/loader.component';
import { DialogComponent } from '../../commons/components/dialog/dialog.component';
import { NgbDateStruct, NgbModal, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { DemandCommand } from '../../commons/class/demand.class';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AcuseDTO } from '../../commons/class/Acuse.class';
import { ENV_TOKEN } from '../../app-module.token';
import { FirmadorService } from '../../commons/shared/firmador.service';
import { TextFieldModule } from '@angular/cdk/text-field';


@Component({
  selector: 'oaj-electronic-demand-itx',
  templateUrl: 'electronicDemand.component.html',
  styleUrls: ['electronicDemand.component.css'],
  imports: [AppModule, OccFilterComponent, ListaArchivosComponent, AlertComponent, LoaderComponent, TextFieldModule],
  providers: [AuthService, ModalIframeService, ConfirmationDialogService, ElectronicDemandService]
})
export class ElectronicDemandComponent implements OnInit  {
  loading = false;
  filterSel!: FiltroExpediente;
  private constService: any;
  uuid = "0";
  isLoadingFile = false;
  public lstDocumentos: any[] = [];
  sMensajeLoad = "Consultando archivos...";
  DemandForm!: FormGroup;
  today = new Date();
  fecEnvEstruc!: NgbDateStruct;
  horaEnvEstruc!: NgbTimeStruct;
  acuse!: AcuseDTO;
  bAcceptDocx = true;
  sFormatos = 'PDF';


  private authService: AuthService = inject(AuthService);
  private modalIframeService: ModalIframeService = inject(ModalIframeService);
  private modalConfirmacionService: ConfirmationDialogService = inject(ConfirmationDialogService);
  private alertService: AlertService = inject(AlertService);
  private _service: ElectronicDemandService = inject(ElectronicDemandService);
  private modalService: NgbModal = inject(NgbModal);
  private fb: FormBuilder = inject(FormBuilder);
  private router: Router = inject(Router);
  readonly environment = inject(ENV_TOKEN);
  private firmador = inject(FirmadorService);
  constructor() {
    this.constService = this.environment;
  }

  ngOnInit(): void {
      if(this.bAcceptDocx){
      this.sFormatos = 'PDF, DOCX';
    }
    else{
      this.sFormatos='PDF'
    }

    this.DemandForm = this.fb.group({
      promovente: ['', [Validators.required, Validators.maxLength(500)]],
    });
    const Autoridad = this.authService.getNameCourt();
    if (Autoridad != null && Autoridad != "") {
      this.DemandForm.get('promovente')?.setValue(Autoridad);
    }
    this.uuid = "0";
  }

  get f() {
    return this.DemandForm.controls;
  }


  /**
   * Funcion para manejar el evento de seleccion de filtro, se asigna el filtro seleccionado a la variable filterSel para ser utilizado posteriormente en la consulta de demanda, se muestra un mensaje de error si ocurre un error durante la asignacion del filtro seleccionado
   * @param filter 
   */
  FiltroSeleccionado(filter: FiltroExpediente) {
    this.filterSel = new FiltroExpediente();
    this.filterSel = filter;
  }

  /**
   * Funcion para cargar los documentos cargados en la pantalla, se hace una consulta al servicio para obtener los documentos dependiendo del guid generado para la transaccion, se muestra una modal con la lista de documentos cargados, se muestra un mensaje de error si ocurre un error durante la consulta de los documentos
   */
  cargaArchivo(): void {

    const IdPantalla = 0;
    const TipoArchivo = this.constService.TipoDoctos.Demandas;
    let FirmaObligatoria = 1;
    const PermisoNoFirma = this.authService.getbPermisoNoFirma();
    if (PermisoNoFirma) {
      FirmaObligatoria = 2;
    }
    else {
      this.openWindowFirma();
      FirmaObligatoria = 1;
      return;
    }
    //console.log("PermisoNoFirma:",PermisoNoFirma);
    if (this.uuid == "0") {
      this.uuid = uuidv4(); //IdTransaction Temporal
    }
    // this.uuid="9c5ef9ba-64bb-4a4e-bd4f-0d727dca99ad"; // pruebas

    const urlFirma = `${this.constService.baseUrlFirma}?userName=${this.authService.getUserName()}&idUser=${this.authService.getIdUser()}&idOrganismo=${this.authService.getIdOrgan()}&IdSystem=1&IdPantalla=${IdPantalla}&IdTransaction=${this.uuid}&tipoArchivo=${TipoArchivo}&fo=${FirmaObligatoria}&ma=1`;
    this.modalIframeService.open('Carga de documentos',
      urlFirma,
      'Cerrar',
      'xl').then((closed) => {
        if (closed) {
          this.uploadFileList();
        }
      }).catch(() => console.error('Ocurrio un error con la modal de iframe'));
  }

  /**
   * Funcion para eliminar documentos de la pantalla, se muestra una modal de confirmación antes de proceder con la eliminación, se hace una consulta al servicio para eliminar el documento dependiendo del id del documento, se muestra un mensaje de error si ocurre un error durante la eliminación del documento
   * @param Documento 
   */
  EliminarDocumentosPantalla(Documento: any): void {
    this.modalConfirmacionService.confirm('Confirmación',
      'Va eliminar el documento con nombre original ' + Documento.NombreOriginal + ', ¿desea continuar?',
      'Aceptar',
      'Cancelar',
      'sm').then((confirmed) => {
        if (confirmed) {
          this._service.EliminarDocumentosPantalla(Documento.IdDocumento).subscribe({
            next: (response: any) => {
              if (response.succcess) {
                this.alertService.success("Se eliminó correctamente el documento", { autoClose: true, keepAfterRouteChange: false });
                this.uploadFileList();
              }
            },
            error: (error) => {
              this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
              return;
            }
          });
        }
      }).catch(() => console.error('Ocurrio un error con la modal de confirmación'));

  }

  /**
   * Funcion para obtener los documentos de la pantalla, se hace una consulta al servicio para obtener los documentos dependiendo del guid generado para la transaccion, se muestra un mensaje de error si ocurre un error durante la consulta de los documentos
   * @param uuid 
   * @returns 
   */

  public GetDocumentosPantalla(uuid: string): Promise<Documents[]> {

    return new Promise((resolve) => {
      this.isLoadingFile = true;
      this._service.getDocumentosPantallaGuid(uuid)
        .subscribe((response: Documents[]) => {
          if (response?.length > 0) {
            this.isLoadingFile = false;

            resolve(response);
          }
          else {
            this.isLoadingFile = false;
            resolve([]);
          }
        }, (error: any) => {
          this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
          this.isLoadingFile = false;
          resolve([]);
        });

    });
  }

  /**
 * Funcion para enviar la demanda, se valida que se hayan llenado todos los campos requeridos y que se haya seleccionado un filtro, se hace una consulta al servicio para enviar la demanda dependiendo de los datos capturados, se muestra un mensaje de error si no se cumplen las validaciones o si ocurre un error durante el envio de la demanda
 */

  EnviarDemanda() {
    this.loading = true;

    if (this.filterSel === undefined) {
      this.loading = false;
      this.alertService.warn("No ha seleccionado la OCC, favor de capturar", { autoClose: true, keepAfterRouteChange: false });
      return;
    }

    if (this.DemandForm.controls['promovente'].value === null || this.DemandForm.controls['promovente'].value.trim() === "") {
      this.loading = false;
      this.alertService.warn("No ha capturado el promovente, favor de capturar", { autoClose: true, keepAfterRouteChange: false });
      return;
    }

    if(this.DemandForm.controls['promovente'].value.length > 500){
      this.loading = false;
      this.alertService.warn("El campo promovente permite un máximo de 500 caracteres, favor de corregir", { autoClose: true, keepAfterRouteChange: false });
      return;
    }

    if (this.lstDocumentos.length === 0) {
      this.loading = false;
      this.alertService.warn("Debe cargar por lo menos un archivo, favor de cargar", { autoClose: true, keepAfterRouteChange: false });
      return;
    }

    this.fecEnvEstruc = { day: this.today.getDate(), month: this.today.getMonth() + 1, year: this.today.getFullYear() };
    this.horaEnvEstruc = { hour: this.today.getHours(), minute: this.today.getMinutes(), second: this.today.getSeconds() }

    const fechaEnv = new Date(
      this.fecEnvEstruc.year,
      this.fecEnvEstruc.month - 1,
      this.fecEnvEstruc.day,
      this.horaEnvEstruc.hour,
      this.horaEnvEstruc.minute,
      this.horaEnvEstruc.second
    );


    const request: DemandCommand = new DemandCommand()
    request.existeEE = false //Validar si sera campo captura
    request.urlEE = "";//Validar si sera campo captura
    request.guid = this.uuid;
    request.idPromovente = 0;//Validar si sera campo captura
    request.promovente = this.DemandForm.get('promovente')?.value;
    request.fecEnvio = this._service.getStringDateUSTime(fechaEnv);
    request.occ = this.filterSel.IdOrgano;
    request.tipoOrganismoOIJ = this.authService.getTipoOrganismo();
    request.oij = this.authService.getIdOrgan();
    request.token = "";

    this._service.EnvioDemanda(request).subscribe({
      next: (response: any) => {
        this.loading = false;
        if (response.succcess) {
          this.acuse = new AcuseDTO;
          this.acuse = response.data;

          const modalRef = this.modalService.open(DialogComponent, { backdrop: 'static', backdropClass: 'customBackdrop', size: 'lg' });
          modalRef.componentInstance.data = { id: 1, obj: this.acuse, Title: "Acuse" };
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          modalRef.componentInstance.response.subscribe((receivedEntry: any) => {
            this.reloadCurrentRoute();
          });

        }
        else {
          this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
        }
      },
      error: (error) => {
        this.loading = false;
        //console.log('error envio Demanda:', error.message);
        this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
      }
    });


  }

  /**
   * Funcion para recargar la ruta actual, se utiliza para actualizar la informacion mostrada en pantalla despues de realizar alguna accion como crear, editar o eliminar una configuracion de dia inhábil sin necesidad de recargar toda la pagina, se muestra un mensaje de error si ocurre un error durante la recarga de la ruta
   */
  reloadCurrentRoute() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]);
    });
  }

  /** * Funcion para obtener el acuse de la demanda, se hace una consulta al servicio para obtener el acuse dependiendo del id de la demanda, se muestra una modal con el detalle del acuse obtenido, se muestra un mensaje de error si ocurre un error durante la consulta del acuse
   * @param idDemanda 
   */
  getAcuse(idDemanda: number) {
    this._service.GetAcuseDemand(idDemanda).subscribe({
      next: (response: any) => {
        this.loading = false;
        if (response.succcess) {
          this.acuse = new AcuseDTO;
          this.acuse = response.data;

          const modalRef = this.modalService.open(DialogComponent, { backdrop: 'static', backdropClass: 'customBackdrop', size: 'lg' });
          modalRef.componentInstance.data = { id: 1, obj: this.acuse, Title: "Acuse" };
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          modalRef.componentInstance.response.subscribe((receivedEntry: any) => {
            this.reloadCurrentRoute();
          });

        }
        else {
          this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
        }
      },
      error: (error) => {
        this.loading = false;
        console.error('error envio Demanda:', error.message);
        this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
      }
    });
}

  // async openWindowFirma(): Promise<void> {
  //   if (this.uuid == "0") {
  //     this.uuid = uuidv4(); //IdTransaction Temporal
  //   }

  //   const paramsFilePath = {
  //     userName: this.authService.getUserName(),
  //     idUser: this.authService.getIdUser(),
  //     idOrganismo: this.authService.getIdOrgan(),
  //     IdSystem: 1,
  //     IdPantalla: 0,
  //     IdTransaction: this.uuid,
  //     tipoArchivo: this.constService.TipoDoctos.Demandas
  // }

  //   const payload = {
  //     ...this.environment.signData,
  //     endPointFilePath: "unc.api.filepath/api/Interconexion/Sign",
  //     tokenFilePath: '',
  //     paramsFilePath: JSON.stringify(paramsFilePath),
  //     idOperacion: this.uuid,
  //     idProceso: this.uuid,
  //     usuarioSistemaCliente: this.authService.getUserName(),
  //     sistemaCliente: this.environment.apiBaseUrl
  //   };

  //   const signOrigin = new URL(this.environment.apiBaseUrl).origin;
  //   const signSrc = `${signOrigin}/Firmav2/sign`;

  //   try {
  //     const response: WindowFirmaResponse = await this.windowFirma.open({
  //       payload,
  //       src: signSrc,
  //       domain: signOrigin,
  //       blockerMessage: 'Procesando firma...',
  //       useBlocker: true,
  //       windowStyle: {
  //         width: 960,
  //         height: 640,
  //         center: true,
  //         features: {
  //           resizable: 'yes',
  //           scrollbars: 'yes',
  //         },
  //       },
  //     });

  //    // console.log('Respuesta window-firma:', response);
      
  //     if (response.payload.success) {
  //       this.isLoadingFile = true;
  //       setTimeout(() => {
  //         this.updateStatusSign();
  //       }, 3000);
  //     } else {
  //       this.alertService.error(response.payload.mensaje, { autoClose: true, keepAfterRouteChange: false });
  //     }

      
  //   } catch (error) {
  //    // console.error('Error en window-firma:', error);
  //     //console.log(`Error: ${String(error)}`);
  //     this.alertService.error(`Error: ${String(error)}`, { autoClose: true, keepAfterRouteChange: false });
  //   }
  // }

  // updateStatusSign(): void {
  //   this._service.updateStatusSign(this.uuid).subscribe({
  //     next: (response: any) => {
  //       const isSuccess = (response?.success ?? response?.succcess) === true;
  //       const message = response?.message ?? 'No fue posible actualizar el estatus de firma.';
  //       if (isSuccess) {
  //         this.uploadFileList();
  //       } else {
  //         this.alertService.error(message, { autoClose: true, keepAfterRouteChange: false });
  //       }
  //     },
  //     error: (httpError: any) => {
  //       const message =
  //         httpError?.error?.message ??
  //         httpError?.message ??
  //         'Ocurrio un error al actualizar el estatus de firma.';

  //       this.alertService.error(message, { autoClose: true, keepAfterRouteChange: false });
  //     }
  //   });
  // }

  async uploadFileList(): Promise<void> {
    this.lstDocumentos = await this.GetDocumentosPantalla(this.uuid);
  }

  async openWindowFirma(): Promise<void> {
    if (this.uuid === "0") {
      this.uuid = uuidv4();
    }

    this.isLoadingFile = true;
    try {
      const signCompletedData = await this.firmador.openWindowFirma(this.uuid, this.constService.TipoDoctos.Demandas, this.bAcceptDocx);
      if (signCompletedData.length > 0) {
        this.lstDocumentos = signCompletedData;
      }
    } finally {
      this.isLoadingFile = false;
    }
  }
 
}
